import React from 'react';
import { Typography } from '@mui/material';

// eslint-disable-next-line
const TypographyDash = (props: any): JSX.Element => {
  return (
    <Typography {...props}> {props.value ? props.value : '--'} </Typography>
  );
};

export default TypographyDash;
